<template>
    <PageHeader :title="(userID) ? sprintf($t('pages.customer.editCustomerPattern'), [data.full_name ?? '']) : $t('pages.customer.newCustomer')" back-to="/customer"/>

    <el-form :model="form.data" ref="customerForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body d-flex flex-column p-9">
                        <div class="row">
                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.customer.cols.firstname') }}</label>
                                <el-form-item prop="firstname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.firstname" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.customer.cols.lastname') }}</label>
                                <el-form-item prop="lastname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.lastname" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.customer.cols.mobilePhone') }}</label>
                                <el-form-item prop="mobile_phone" :rules="$validation.getMessage(['required'])">
                                    <MobilePhoneInput v-model:data="form.data.mobile_phone" @mobile-phone-number="handleMobilPhoneNumber" :disabled="form.data.id"/>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item class="m-0">
                                <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                    <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                    <span v-if="form.loading" class="indicator-progress">
                                        {{ $t("messages.wait") }}
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import Plate from "@/components/plate/Plate.vue";
import PageHeader from "@/components/page-header/PageHeader.vue";
import MobilePhoneInput from "@/components/custom-mobile-phone-selector/";

export default {
    name: "_id",
    components: {PageHeader, MobilePhoneInput, Plate},
    data() {
        return {
            tabModel: 'general',
            company: {},
            data: {},
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {
                    firstname: '',
                    lastname: '',
                    mobile_phone: '',
                },
            },
            rules: {}
        }
    },
    computed: {
        userID() {
            return this.$route.params.id;
        },
        saveData() {
            return this.$store.state.customer.save.data;
        },
        selectedCompany() {
            return this.$store.state.company.authorized.selectCompany
        }
    },
    created() {

    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.customerList"), []);

        if (this.userID && this.userID > 0) {
            this.loadUser();
        } else {
            this.resetForm();
        }
    },
    methods: {
        loadUser(userID = this.userID) {
            this.$store.dispatch("customer/show", {
                id: userID
            }).then(() => {
                this.data = this.saveData;
                this.form.data = this.saveData;
            });
        },
        onSubmit() {
            this.$refs.customerForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.$store.dispatch('customer/update', {
                            id: this.form.data.id,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let userID = response.data.id;
                                    this.$router.push({
                                        path: "/customer/save/" + userID
                                    });

                                    this.loadUser(userID);
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('customer/add', {
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let userID = response.data.id;
                                    this.$router.push({
                                        path: "/customer/save/" + userID
                                    });

                                    this.loadUser(userID);
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        handleMobilPhoneNumber(data) {
            this.form.data.mobile_phone = data.number;
        },
        resetForm() {
            this.form.data.id = null;
            this.form.data.firstname = '';
            this.form.data.lastname = '';
            this.form.data.mobile_phone = '';
        },
    },
    watch: {
        userID(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (!newValue){
                    this.resetForm()
                }
            }
        }
    }
}
</script>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
</style>